// extracted by mini-css-extract-plugin
export var chevron = "_ld-3";
export var chevronRotated = "_ld-4";
export var image = "_ld-1";
export var imageContainer = "_ld-0";
export var shippingAddress = "_ld-2";